export default __webpack_public_path__ + "static/curiosocirco-solo-ojos-af7e1468e4af9a5205783943abca5d31.png";